import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="dark min-h-screen bg-anthracite-900 flex flex-col items-center justify-center gap-3 px-6">
        <Loader2 className="w-8 h-8 text-electric animate-spin" />
        <p className="text-slate-400 text-sm">Fiók betöltése…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/belepes" replace />;
  return children;
}
